import { IS_DEV_OR_STG } from "./constants";

// default values

export const FEATURE_FLAGS = {
  RESET_PASSWORD: {
    desc: "allows users to change their passwords.",
    value: true,
  },
  SAVING_GAMES: {
    desc: "enable the displaying the played session games",
    value: true,
  },
  SAVING_DRAWINGS: {
    desc: "enable the feature to save and show saved drawings in session",
    value: true,
  },
  GAME_TIMER: {
    desc: "enable the therapist to start a timer for the student to see",
    value: true,
  },
  PASSWORD_EXPIRATION: {
    desc: "reminds users that the password will expire soon.",
    value: false,
  },
  SESSION_LOGOUT_TIMEOUT: {
    desc: "automatically logs out the user after X time.",
    value: false,
  },
  NEW_VERSION_CHECK: {
    desc: "runs interval to check for new versions of the frontend and shows toast when new version found",
    value: true,
  },
  INTERCOM_PLUGIN: {
    desc: "3ed party intercom integeration",
    value: false,
  },
  ACCESSIBILITY_PLUGIN: {
    desc: "adds 3ed party accessibility plugin",
    value: false,
  },
  SESSION_STUDIO: {
    desc: "shows and enables the studio in session",
    value: false,
  },
  SESSION_H5P: {
    desc: "shows and enables the h5p games in session",
    value: true,
  },
  SESSION_WB: {
    desc: "shows and enables the whiteboard tool sessions",
    value: true,
  },
  SESSION_YT: {
    desc: "shows and enables the youtube tool sessions",
    value: true,
  },
  SESSION_SCREENSHARE: {
    desc: "shows and enables the screenshare tool sessions",
    value: true,
  },
  SESSION_GOOGLE_SLIDES: {
    desc: "allow using google slides library in session",
    value: false,
  },
  FULLSTORY_PLUGIN: {
    desc: "3ed party fullstory plugin integeration",
    value: IS_DEV_OR_STG,
  },
  S_PROFILE_READING_REPORT: {
    desc: "show the widget reading report on the student profile",
    value: true,
  },
  S_PROFILE_SPELLING_REPORT: {
    desc: "show the widget spelling report on the student profile",
    value: true,
  },
  S_PROFILE_SPEECH_REPORT: {
    desc: "show the widget speech language report (h5p games) on the student profile",
    value: true,
  },
  RECURRENCE_PICKER: {
    desc: "It shows the picker for creating and updating recurring sessions",
    value: true,
  },
  SESSION_CHAT: {
    desc: "show and enable chat between therapist and students",
    value: true,
  },
  STUDNET_GRADE_DIALOG: {
    desc: "show the grade level dialog in the beginning of the session for the therapist",
    value: true,
  },
  METRIC_CLIENT_LOGS: {
    desc: "write events to treatment metrics table (excluding opentok events)",
    value: true,
  },
  METRIC_OPENTOK_LOGS: {
    desc: "write opentok events to treatment metrics table",
    value: false,
  },
  SNOW_NAVIGATION: {
    desc: "add snow effect to left side menu",
    value: true,
  },
  CCSS_FILTERS: {
    desc: "filter games by common core standards",
    value: true,
  },
  S_PROFILE_PLAY_RECORDING: {
    desc: "show the play recording button on the student profile widgts",
    value: true,
  },

};
